export const getUser = `
{
    user @client{
      recordtypeid
      sfid
      id
      assigned_cmdi__c,
      secondary_cmdi__c,
      user_type__c,
      ekyc_complete__c
      reporting_to_ammd__c
      role
      this_ekyc_popup_complete__c
      teacher_level__c
      isintroduction_complete__c
      phone
      approve_agreement__c
    }
  }
`;
